import { Block2, BlockContentType } from '~/models/Block'
import { LinkEntityMapper } from '~/passporter-services/link/entityMapper'
import { ProfileEntityMapper } from '~/passporter-services/profile/entityMapper'
import { DestinationMapperEntity } from '~/passporter-services/destination/toEntity'
import { SpotEntityMapper } from '~/passporter-services/spot/entityMapper'
import { ItineraryEntityMapper } from '~/passporter-services/itinerary/entityMapper'
import { ApiBlockType } from '~/passporter-services/block/apiTypes'
import { GuideEntityMapper } from '../guide/entityMapper'
import { ProductEntityMapper } from '../product/entityMapper'

export class BlockEntityMapper {
	static toBlocks<ContentType extends BlockContentType = BlockContentType>(
		blocks: any[]
	): Block2<ContentType>[] {
		return blocks.map((block) => this.toBlock<ContentType>(block))
	}

	static toBlock<ContentType extends BlockContentType = BlockContentType>(
		block: any
	): Block2<ContentType> {
		return {
			id: block.id,
			subtitle: block.subtitle,
			title: block.title,
			header: block.header,
			description: block.description,
			image: block.image,
			type: block.type,
			button: block.button,
			link: block.link,
			content: this.toBlockContent(block.type, block.content) as unknown as ContentType[],
		}
	}

	static toBlockContent = (type: ApiBlockType, content: BlockContentType[]) => {
		const parsers: Record<ApiBlockType, (content: any) => BlockContentType[]> = {
			itinerary: (content: any) => ItineraryEntityMapper.toItineraries(content),
			traveler: (content: any) => ProfileEntityMapper.toProfiles(content),
			destination: (content: any) => DestinationMapperEntity.toDestinations(content),
			spot: (content: any) => SpotEntityMapper.toSpots(content),
			guide: (content: any) => GuideEntityMapper.toGuides(content),
			product: (content: any) => ProductEntityMapper.toProducts(content),
			links: (content: any) => LinkEntityMapper.toLinks(content),
		}
		const parser = parsers[type]

		return parser ? parser(content) : content
	}
}
